import { Link } from 'react-router-dom'
import LazyLoad from "react-lazyload";
const ManifoldOpportunities = () => {
  return (
    <>
      <div className="breadcrumb">
        <h2>Manifold Opportunities</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li>
                    <li>Features</li>
                    <li>|</li>
          <li>Manifold Opportunities</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-4"> 
              <p>The school provides ample opportunities to develop the talents of the students and from themselves into individuals of integrated personalities. The students take membership in different clubs like Art Club, Sports Club, Science Club and Literary Association like elocution, quiz, extempore, creative story writing, Calligraphy, poem composing and recitation, article writing, essay writing, drawing and painting, poster making, cooking, table setting, bouquet making, Preparation of notice board, vocal & instrumental music etc. conducted by the above said clubs. The students also participate in various activities like football, volleyball, kho-kho, cricket, shooting and different athletic events. The school has a well trained group of teacher for arts & craft, drawing music dance and physical education.</p>
            </div>
          </div>
          <div className="row club mb-3">
            <div className="col-12">
            <h3 className="heading text-center mb-4">School Clubs</h3>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club1.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Art Club</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club2.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Sports Club</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club3.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Science Club</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club4.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Literary Association</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club5.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Quiz</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club6.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Extempore</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club7.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Story Writing</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club8.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Calligraphy</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club9.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Poem Composing</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club10.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Poem Recitation</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club11.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Article Writing</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club12.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6> Essay Writing</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club13.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Drawing &amp; Painting</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club14.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Poster Making</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club15.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Cooking</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club16.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Table Setting</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club17.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Bouquet Making</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club18.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Vocal Music </h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/club19.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Instrumental Music</h6>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 class="subhead mt-3">School Activities</h3>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act1.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Football</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act2.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Volleyball</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act3.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Kho-Kho</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act4.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Cricket</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act5.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Shooting </h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act6.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6> Physical Education.</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="manifold_opprtunity">
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/act7.png" className="img-fluid mx-auto d-block" alt="St. Francis School, Amritsar" /></LazyLoad>
                <h6>Athletic </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ManifoldOpportunities
